class EstimatorController {
  constructor () {
  }
}

EstimatorController.$inject = [];

export {EstimatorController};



/** WEBPACK FOOTER **
 ** ./src/app/components/estimator/estimator.controller.js
 **/